export default "__VITE_ASSET__BwA6Jmk3__"